import React, { useState }  from 'react';
import { PageHeader, Page, PageContent, Box, Text, Image, Heading, Tabs, Tab, Paragraph } from 'grommet';
import { ViewTabContent } from '../../components/ViewTabContent';
//import Iframe from 'react-iframe';

export const UserJourneySummaryView = () => {
  //const [user, setUser] = useState(defaultUser);
  //const size = useContext(ResponsiveContext);


  const [activeViewTab, setActiveViewTab] = useState(0); // For the first tab section

  return (
    <Page flex="grow" background="background-back">

      <Box background="url('../images/home-banner.png')" height="200px" margin={{ top: 'none'}}>
        <Box margin={{ top: 'none', left: 'large' }}>
          <PageHeader pad={{ top: '15px', bottom: '15px' }} 
                      title={<Text color="black" size="xxlarge" weight="bolder" style={{fontWeight: 'bold'}}>HPE User Journey Display</Text>} 
                      subtitle={<Text color="black" size="xxlarge">Lead to Cash</Text>}
                      style={{ color: 'black' }}/>
        </Box>                  
      </Box> 

      <PageContent flex="grow">

          <Heading size="medium" margin={{ top: 'large' }}>User Journeys by <b>Product</b> </Heading>
          <Tabs activeIndex={activeViewTab} onActive={setActiveViewTab} justify="start">
            <Tab title="SaaS">
              <ViewTabContent>
                <Box direction="row" width="100%" pad={{ top: '0px' }} flex="grow">
                  <Image fit="cover" src="../images/user-journey-saas.png"/>
                </Box>
              </ViewTabContent>
            </Tab>
            <Tab title="IaaS">
              <ViewTabContent>
                <Paragraph margin="none">Coming soon!</Paragraph>
              </ViewTabContent>
            </Tab>     
            <Tab title="eCommerce">
              <ViewTabContent>
                <Paragraph margin="none">Coming soon!</Paragraph>
              </ViewTabContent>
            </Tab>    
            <Tab title="CAPEX">
              <ViewTabContent>
                <Paragraph margin="none">Coming soon!</Paragraph>
              </ViewTabContent>
            </Tab>     
            <Tab title="Lease">
              <ViewTabContent>
                <Paragraph margin="none">Coming soon!</Paragraph>
              </ViewTabContent>
            </Tab>                                                                           
          </Tabs>

      </PageContent>  

    </Page>
  );
};